<!-- TODO: Component under development. Commented code will be removed or added as the Sports module refactoring progresses. -->
<div
  class="sports-group-containter"
  [betType]="betType"
  bet-display
>
  <!--
  obsolete. required for the has-4-button css class
  [desktop]="true" 
-->
  <ng-content />
</div>